import React from 'react';
import { BodyText, Button, FlexColumn, FlexRow, TableData } from '@make-software/cspr-design';
import styled from 'styled-components';
import { Offer } from 'app/console-api/offers/offers';
import { StyledCardRow, SourceInfoWrapper } from 'app/components/common/common-styles';
import { DealTradeChip } from 'app/components/common/deal-trade-type/deal-trade-chip';
import { PluginChip } from 'app/components/management/common/plugins/plugin-chip/plugin-chip';
import { TaskShortPreview } from 'app/components/management/apps/deals/view/task-short-preview';

const StyledInfoName = styled.div(({ theme }) =>
  theme.withMedia({
    fontSize: '13px',
    lineHeight: '20px',
    color: theme.styleguideColors.contentSecondary
  })
);

const TableCellWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    padding: '8px 0'
  })
);

const StyledButton = styled(Button)(({ theme }) =>
  theme.withMedia({
    width: ['70px', '100px', '120px']
  })
);

interface MarketplaceAppOfferItemProps {
  offer: Offer;
  onJoin: (offer: Offer) => void;
}

export const MarketplaceAppOfferItem = ({ offer, onJoin }: MarketplaceAppOfferItemProps) => {
  return (
    <StyledCardRow>
      <TableData>
        <TableCellWrapper>
          <TaskShortPreview name={offer.name} description={offer.description} />
        </TableCellWrapper>
      </TableData>
      <TableData>
        <FlexColumn gap={8}>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>Deal:</StyledInfoName>
            <DealTradeChip type={offer.tradeType} />
          </FlexRow>
          {offer.pluginID > 0 && (
            <FlexRow gap={8} align={'center'}>
              <StyledInfoName>Type:</StyledInfoName>
              <PluginChip id={offer.pluginID} />
            </FlexRow>
          )}
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn gap={8}>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>Updated:</StyledInfoName>
            <BodyText size={3} scale={'sm'}>
              {new Date(offer.updatedAt).toLocaleDateString()}
            </BodyText>
          </FlexRow>
          <FlexRow gap={8} align={'center'}>
            <StyledInfoName>Min Quota:</StyledInfoName>
            <BodyText size={3} scale={'sm'} monotype>
              {offer.minQuota}
            </BodyText>
          </FlexRow>
        </FlexColumn>
      </TableData>
      <TableData align="right">
        <StyledButton onClick={() => onJoin(offer)}>Request</StyledButton>
      </TableData>
    </StyledCardRow>
  );
};
